// Constantes para el módulo de Despachos
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CORREDOR_OPTIONS = ['JPMUÑOZ', 'ILARRA', 'DIRECTO'];

export const DISPATCH_STATUS = {
  PENDING: 'Pendiente',
  IN_PROGRESS: 'En Proceso',
  FINISHED: 'Finalizado'
};

export const STATUS_STYLES = {
  'Pendiente': 'bg-amber-50 text-amber-700 border-amber-200',
  'En Proceso': 'bg-sky-50 text-sky-700 border-sky-200',
  'Finalizado': 'bg-emerald-50 text-emerald-700 border-emerald-200'
};

// Estados iniciales de formularios
export const INITIAL_FORM_DATA = {
  importadora_id: '',
  load_date: '',
  delivery_date: '',
  dispatch_number: '',
  crt_number: '',
  freight_value_per_ton: 0,
  broker: '',
  truck_count: 1,
  status: 'En Proceso'
};

export const INITIAL_ASSIGN_DATA = {
  company_id: '',
  truck_id: '',
  trailer_id: '',
  driver_id: '',
  negocio_id: '',
  compra_id: ''
};

export const INITIAL_TRUCK_DATA = {
  order: 1,
  company_id: '',
  truck_id: '',
  trailer_id: '',
  driver_id: '',
  load_date: '',
  delivery_date: '',
  broker: '',
  freight_value: 0,
  kg_loaded: 0,
  kg_unloaded: 0,
  destination: '',
  commune: '',
  sale_price: 0,
  sale_invoice: '',
  guide_number: '',
  transport_invoice: ''
};
